import React, { createContext, useState, useContext } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Only check auth when needed
  const checkAuth = async () => {
    if (isAuthenticated) return true; // Already authenticated
    
    setIsLoading(true);
    try {
      await api.get('/auth/verify'); // Lightweight endpoint that just verifies token
      setIsAuthenticated(true);
      return true;
    } catch (error) {
      setIsAuthenticated(false);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const login = async (credentials) => {
    const response = await api.post('/login', credentials);
    setIsAuthenticated(true);
    return response;
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } finally {
      setIsAuthenticated(false);
    }
  };

  return (
    <AuthContext.Provider value={{ 
      isAuthenticated, 
      setIsAuthenticated,
      isLoading,
      checkAuth,
      login,
      logout 
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 